import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

/**
 * Generates a FormGroup Custom Validator that compares the values of the
 * children form controls
 *
 * @param controlName
 * @param compareControlName
 * @param compareControlsValuesFn Function used to compare between values.
 *        Default function compares controlName value being greater or equal to
 *        compareControlName value.
 */
export function generateRangeValidators(
  controlName: string,
  compareControlName: string,
  compareControlsValuesFn = (value: number, compareValue: number) => value >= compareValue
) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const compareControl = formGroup.controls[compareControlName];
    const areBothFilled = control.value != null && compareControl.value != null;

    const periodFormValidator: ValidationErrors =
      areBothFilled && compareControlsValuesFn(control.value, compareControl.value) ? { invalidPeriod: true } : null;

    // merge the new error with the existing compare control errors if any
    const compareControlErrors = compareControl.errors;
    if (compareControlErrors || periodFormValidator) {
      compareControl.setErrors(Object.assign({}, compareControlErrors, periodFormValidator));
    }

    return periodFormValidator;
  };
}
